import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import {
  Component,
  HostListener,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountService, buildAbsoluteReturnUrl } from "@done/ngx-essentials";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { Menu } from "../../shared/models/menu.model";
import { MenuService } from "../../shared/services/menu.service";

@Component({
  selector: "app-login-layout",
  templateUrl: "./login-layout.component.html",
  styleUrls: ["./login-layout.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginLayoutComponent implements OnInit {
  innerWidth: any;
  menus: Menu[];
  currentPage: string;
  hideContainer: boolean = false;
  logingIn: boolean = false;
  form: UntypedFormGroup;
  isBusy: boolean = false;
  backgroundImage: string = "./assets/images/login-bg.jpg";

  // Não remover o ISHANDSET ele serve para fazer o colapse do MENU
  isHandset$: Observable<boolean> = this._breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _menuService: MenuService,
    private _accountService: AccountService,
    private _sanitizer: DomSanitizer,
    private _router: Router,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.init();
  }

  async init() {
    this.innerWidth = window.innerWidth;

    this._menuService.hiddenContainer.subscribe(
      (hide: boolean) => (this.hideContainer = hide),
    );

    if (this._accountService.isLoggedIn()) {
      const user = await this._accountService.me();

      if (!!user) this._router.navigate(["/"]);
    }

    // Background Image
    fetch(`${environment.apiGateway}/workspace/random-image/download`)
      .then(async (resp) => {
        const result = await resp.json();
        this.backgroundImage = result.url;
      })
      .catch((_) => {});
  }

  isPageActive(url: string): boolean {
    return this.currentPage == null
      ? false
      : this.currentPage.indexOf(url) > -1;
  }

  login(): SafeUrl {
    // AT-1224 (RF04): se o guard mandou pra cá com uma rota funda capturada, propaga ela
    // (em vez da raiz do app) como returnUrl pro login de verdade do Workspace.
    const returnUrl = this._route.snapshot.queryParamMap.get("returnUrl");
    const target = buildAbsoluteReturnUrl(
      environment.donePointerApp,
      returnUrl,
    );

    return this._sanitizer.bypassSecurityTrustUrl(
      `${environment.doneWorkspaceApp}/login?returnUrl=${encodeURIComponent(target)}`,
    );
  }
}
